import { GeoPoint, Timestamp } from 'firebase/firestore';

const IGNORE_KEYS = [
  'createdAt',
  'createdBy',
  'createdAtParts',
  'updatedAt',
  'updatedBy',
  'uid',
  '_context_',
  '_metadata_',
];

const isObject = (input: unknown): boolean => {
  if (!input) return false;
  if (Array.isArray(input)) return false;
  if (typeof input !== 'object') return false;
  if (input?.constructor !== Object) return false;
  return true;
};

const isZoneCheckpoint = (key: string) =>
  key === 'checkPoints' || key === 'airports' || key === 'trainStations';

const cleanZoneCheckpoints = (input: unknown): unknown => {
  return (input as any[]).map((entry) => ({
    ...entry,
    coords: entry.coords
      ? {
          latitude: (entry.coords as GeoPoint)?.latitude ?? 0,
          longitude: (entry.coords as GeoPoint)?.longitude ?? 0,
        }
      : null,
  }));
};

const cleanGeopoint = (input: GeoPoint) => ({
  latitude: input.latitude,
  longitude: input.longitude,
});

export const clean = <T extends Record<string, any>>(input: T, child?: boolean): T => {
  return Object.entries(input)
    .filter(([key, value]) => {
      if (typeof value === 'undefined') return false;
      if (!child) {
        if (IGNORE_KEYS.includes(key)) return false;
        if (key.startsWith('$')) return false;
      }
      return true;
    })
    .reduce((memo, [key, value]) => {
      // FIXME: rimuovere e trovare altra soluzione
      if (key === 'peakCoords' || key === 'baseCoords') {
        return { ...memo, [key]: cleanGeopoint(value) };
      }
      if (isZoneCheckpoint(key)) {
        return { ...memo, [key]: cleanZoneCheckpoints(value) };
      }
      if (value instanceof GeoPoint) {
        return { ...memo, [key]: cleanGeopoint(value) };
      }
      if (value instanceof Timestamp) {
        return { ...memo, [key]: value.toDate() };
      }

      if (isObject(value)) {
        return { ...memo, [key]: clean(value, true) };
      }
      if (Array.isArray(value) && value.every((v) => isObject(v))) {
        // console.log(value.map((v) => clean(v, true)));
        return { ...memo, [key]: value.map((v) => clean(v, true)) };
      }
      return { ...memo, [key]: value };
    }, {} as T);
};
